import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataService } from '../service/data.service';
import { Observable, TimeoutError } from 'rxjs';
import { Editorcontrolitem } from '../models/editorcontrolitem.model';
import { BaseComponent } from '../base.component';
import { Guid } from '../util/guid';
import * as jQuery from 'jquery';


@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ToolbarComponent extends BaseComponent implements OnInit {

  groups: string[] = ["Form", "Layout"];
  activeGroup: string = "Layout";
  searchText: string = "";
  manyToOne: any[] = [];
  panelExapndedState = {
    'main': false
  };


  constructor(data: DataService) {
    super(data);
  }

  ngOnInit() {
    jQuery("h4").click(function () {
      jQuery(".mat-expansion-panel").click();
    });
  }

  expandAllPanels() {
    for (let key in this.panelExapndedState) {
      this.panelExapndedState[key] = true;
    }
  }

  initExpandStatus(exapdnStatusKey) {
    if (this.panelExapndedState[exapdnStatusKey] == null) {
      this.panelExapndedState[exapdnStatusKey] = false;
    }
    return true;
  }

  checkShow(el, gr, text) {

   if (el.ControlType == this.activeGroup) {
      if (this.searchText != null && this.searchText.length > 0) {

        this.expandAllPanels();

        var txt = "";
        
        if (this.activeGroup == "Form") {
          txt = el.Property;
        } else {
          txt = this.translate("galis_js_" + el.Type);
        }

        var indexOf = txt.toLowerCase().indexOf(this.searchText.toLowerCase());

        if (indexOf !== -1) {
          return true;
        } else {
          return false;
        }

      } else {
        return true;
      }

    } else {
      return false;
    }
  }

  checkManyToOne() {
    this.data.editor.Controls
  }

  trackByFn(index, item) {
    return index; // or item.id
  }


  builderDrag(e: any) {
    const item = e.value;
    item.ControlClientId = Guid.newGuid();
  }

  checkCopy(item) {
    return false;
  }

  isUsed(checkItem, isComplex = false) {
    var res = false;
    for(var i = 0; i<this.data.editor.Controls.length; i++){
      var item = this.data.editor.Controls[i];
      if (this.checkUsedRule(checkItem, item, isComplex)){
        res = true;
        break;
      }

      if (item.Children != null && item.Children.length > 0) {
        res = this.checkUsed(item.Children, checkItem, isComplex);
         if(res == true){
          break;
        }
      }
    }

    return res;
  }

  checkUsed(items: Editorcontrolitem[], checkItem, isComplex = false): boolean {

    var res = false;

    for(var i=0; i<items.length; i++){
      var item = items[i];

      if (this.checkUsedRule(checkItem, item, isComplex)){
        res = true;
        break;
      }

      if (item.Children != null && item.Children.length > 0) {
        res = this.checkUsed(item.Children, checkItem, isComplex);
        if(res == true){
          break;
        }
      }
    }

    return res;
  }

  checkUsedRule(checkItem, item, isComplex = false) {
    if (checkItem.Type === item.Type && (this.activeGroup.toLocaleLowerCase() === "layout" || this.activeGroup.toLocaleLowerCase() ==="clientui" )) {
      return true;
    } 

    if(checkItem.Type == item.Type && this.activeGroup.toLocaleLowerCase() === "form"){

      if(isComplex){

        if(checkItem.Settings.BindingPropertyName!=null && checkItem.Settings.BindingPropertyName === item.Settings.BindingPropertyName){
          return true;
        }

        if(checkItem.Settings.EntityName!=null && checkItem.Settings.EntityName === item.Settings.EntityName){
          return true;
        }

      }else{
        if(checkItem.Property === item.Settings.BindingPropertyName) {
            return true;
        }
        if(checkItem.Settings.EntityName!=null && checkItem.Settings.EntityName === item.Settings.EntityName){
          return true;
        }
      }
    }

    return false;
  }

  changeCurrentGroup(group) {
    if (this.activeGroup != group) {
      this.activeGroup = group;
      this.searchText = "";
    }
  }
}
